import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { TermLink } from '../TermLink'
import { Grid, Text, DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { TransProps } from 'react-i18next'

export const Terms: FunctionComponent = () => {
  const { t } = useTranslation()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const linkColor = isArcadeDesignLanguage ? 'Black' : 'Orca'

  const getTranslation = (): TransProps<string> => {
    const components = {
      terms: <TermLink key='verify-identity-passport-terms' href={t('common:termsOfServiceUrl')} color={linkColor} fontFace='CashSansMono' />,
      privacy: <TermLink key='verify-identity-passport-privacy' href={t('common:privacyPolicyUrl')} color={linkColor} fontFace='CashSansMono' />,
    }

    return { i18nKey: 'verifyIdentity:passport:terms', components }
  }

  return (
    <Grid>
      <Text color='Gray40' size='XXS' fontFace='CashSansMono'>
        <Trans {...getTranslation()} />
      </Text>
    </Grid>
  )
}
